var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("workspace.dashboard")))]),_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"d-flex mb-4",staticStyle:{"gap":"20px","flex-wrap":"wrap"}},[_c('workspace-member-card'),_c('workspace-organization-card')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }